export { Tabs } from "@mantine/core";
export type {
  TabsProps,
  TabProps,
  TabsListProps,
  TabsPanelProps,
} from "@mantine/core";
export { getTabsOverrides } from "./Tabs.styled";
